module.exports = __webpack_public_path__ + "img/ringcase.1f844d1.jpg";